import { findDeepGetTask } from '../../../GanttVisualization/GanttVisualization.helper'; // Corrected path

export const getIsOdd = ({ gantt, task }, column) =>
  gantt?.oddColsConfig && task.type === 'activitytask' // Assuming similar logic for now
    ? gantt.oddColsConfig[column]
    : false;

// Placeholder for getTaskFromLookahead if needed for Schedule, or to be adapted
export const getTaskFromLookahead = (activities, gantt, taskId) =>
  // This might need a different implementation for the Schedule context
  activities && gantt ? findDeepGetTask(activities, 'id', taskId) : null;

export const getIsOnlyReadElement = (onlyRead, task, subtradeRole) =>
  onlyRead || task.readonly || (subtradeRole && subtradeRole.isSubtradeRole); // Assuming similar logic
